module.exports = __webpack_public_path__ + "img/2.e1709448.png";